import { IConferenceRoles, IConferenceAccessSettings } from "taskpane/models/interfaces";
import { API } from "taskpane/constants/api";
import { AccessBitPosition } from "taskpane/models/enums";
import setBitByPosition from "./setBitByPosition";

const getRolesBySettings = (settings: IConferenceAccessSettings): IConferenceRoles => {
  const { accessMicro, accessVideo, accessDemonstration, accessWaitingHall } = settings;
  let defaultPermission: number = API.defaultPermission;

  defaultPermission = setBitByPosition(defaultPermission, AccessBitPosition.micro, accessMicro);
  defaultPermission = setBitByPosition(defaultPermission, AccessBitPosition.video, accessVideo);
  defaultPermission = setBitByPosition(defaultPermission, AccessBitPosition.demonstration, accessDemonstration);
  defaultPermission = setBitByPosition(defaultPermission, AccessBitPosition.waitingHall, accessWaitingHall);

  return {
    default: {
      permissions: defaultPermission,
    },
    moderator: {
      permissions: API.moderatorPermission,
    },
  };
};

export default getRolesBySettings;
